module.exports = __webpack_public_path__ + "static/media/horizon_wallpaper.9287d071.jpg";